import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import { urls } from "../../Utils/url";
import { showToast } from "../Toast";
import { toast } from "react-toastify";

export const getUserData = (getUser, token, history) => {
  ApiCall("get", urls.User, null, "getUser", token, function (e) {
    getUser(e.data);
    history.push("/Main");
  });
};

const Login = async (
  code,
  phoneNumber,
  setToken,
  login,
  getUser,
  setLoading,
  history
) => {
  const body = { mobile_number: phoneNumber, code: code, platform: "web" };
  if (code !== "") {
    setLoading(true);
    ApiCall(
      "post",
      urls.Login,
      body,
      "Login",
      null,
      function (e) {
        setToken(e.data.token);
        getUserData(getUser, e.data.token, history);
        login();
        setLoading(false);
      },
      () => setLoading(false)
    );
  } else {
    toast.warn("لطفا کد ارسال شده را وارد نمایید", {
      position: "bottom-center",
      autoClose: 5000,
    });
  }
};

export const Button = ({ mobile, code, getUser, setToken, login }) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  return (
    <div
      className="BlueButtonAbsolute"
      id="Billhistory"
      style={{ animationDelay: "0.3s" }}
      onClick={() =>
        Login(code, mobile, setToken, login, getUser, setLoading, history)
      }
    >
      {loading ? (
        <BeatLoader size={5} color={"white"} loading={true} />
      ) : (
        <span>ادامه</span>
      )}
    </div>
  );
};
